/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';

/**
 * Find the product in array of products considering product id.
 * @param productId - The searched product id.
 * @param products - The array of products in which search is executed.
 * @returns - The found product.
 */
export function getProductByProductId(productId: number | undefined, products?: SimpleProduct[]): SimpleProduct | undefined {
    if (productId !== undefined && ArrayExtensions.hasElements(products)) {
        return products.find(product => {
            return productId === product.RecordId;
        });
    }

    return undefined;
}
